module.exports = __webpack_public_path__ + "img/vipgroup_defaultgroup_icon.3e532702.png";